var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","color":"orange"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [(_vm.show)?_c('v-chip',_vm._g(_vm._b({staticClass:"text-uppercase mr-2 cat-label-no-supported-country",attrs:{"label":"","small":"","color":"secondary"}},'v-chip',attrs,false),on),[_c('v-icon',[_vm._v("error_outline")])],1):_vm._e()]}}])},[_c('span',[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }